/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxBank from "../../../util/remote/ajaxBank";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import Loader from "../../../Components/Common/Loader";
import Pagination from "../../../Components/Common/Pagination";
import SchoolCreditBalancesSearchForm from "../../../Components/Common/Statistics/SchoolCreditBalancesSearchForm";


function SchoolBuzztimeCreditBalancesPage() {
    const [query, setQuery] = useState("");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);

    const [overallCreditBalance, setOverallCreditBalance] = useState(false);

    const [meta, setMeta] = useState([]);
    const [creditBalances, setCreditBalances] = useState([]);
    const { schoolDetails } = useContext(SchoolContext);
    const schoolID = schoolDetails.school_id;
  useEffect(() => {
      if (query) {
          searchCreditBalances();
      } else {
          getCreditBalances(page, schoolID);
      }
  }, [page, schoolID]);

  useEffect(() => {
        getOverallCreditBalance();
}, [schoolID]);

  const getOverallCreditBalance = async () => {
      const server_response = await ajaxBank.fetchSchoolCreditBalance(schoolID);
      if (server_response.status === "OK") {
        setOverallCreditBalance(server_response.details);
      } else {
        setOverallCreditBalance("404");
      }
    };
  
  const getCreditBalances = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxStudent.listAllSchoolCreditBalances(currentPage, schoolID);
    setLoading(false);

    if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setCreditBalances(server_response.details.data || []);
    } else {
        setCreditBalances([]);
    }
};

const searchCreditBalances = async (e) => {
    if (e) {
        e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxStudent.searchAllCreditBalances(page, schoolID, query);
    setLoading2(false);
    if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setCreditBalances(server_response.details.data || []);
    } else {
        setCreditBalances([]);
    }
};

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setBalances = (e) => {
    e.preventDefault();
    setQuery("");
    setPage(1);
    getCreditBalances(1);
    
  };

  const exportToPDF = () => {
      const pdf = new jsPDF("p", "pt", "a4");
      const columns = ["Student Name", "Buzz Number", "School Name", "Class", "Buzztime Credit"];
      const data = creditBalances.map(item => [
        item.user,
        item.username,
        item.school,
        item.group,
        item.balance.total_c
      ]);
  
      pdf.autoTable({ head: [columns], body: data });
      pdf.save("credit_balances_list.pdf");
    };


  return (
    <AppContainer title="Buzztime Credit Balances">
      <Toaster position="top-center" reverseOrder={false} />
        
       
        <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            UGX. {overallCreditBalance? overallCreditBalance.total_c : "0"}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Credit Balance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-12 col-md-12 col-12 col-sm-12">
                <div className="row">
                <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Buzztime Credit Balances List"
          subtitle="List of all the school students with their credit balances sorted in ascending order"    
        />
        <div class="dropdown">

          <Link class="" onClick={setBalances} role="button"><i class="fas fa-redo-alt ml-3"></i></Link>
          <Link class="" onClick={exportToPDF} role="button"><i class="fas fa-download ml-3"></i></Link>

        </div>
      </div>

      <SchoolCreditBalancesSearchForm student={query} setStudent={setQuery}
      searchCreditBalances={searchCreditBalances} setPage={setPage} resetSearch={setBalances}/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">No.</th>
                <th scope="col">Student Name</th>
                <th scope="col">Buzz Number</th>
                <th scope="col">Class / Group</th>
                <th scope="col"> Buzztime Credit</th>
                
                </tr>
            </thead>
            <tbody>
                {creditBalances.length > 0 ? (
                    creditBalances.map((item, index) => (
                    <tr key={index}>
                        

                        <td>{index + 1} </td>
                        
                        <td><OverlayTrigger placement="top" overlay={
                                                                <Tooltip id="refresh-tooltip">
                                                                    View Statement
                                                                </Tooltip>}><Link to={`/credit-balances/statement/${item.user_id}?username=${encodeURIComponent(item.username)}&user=${encodeURIComponent(item.user)}&balance=${encodeURIComponent(item.balance.total_c)}`}>{item.user}
                                                                </Link></OverlayTrigger></td>
                        <td>{item.username}</td>

                        <td>{item.group}</td>
                        <td>{item.balance.total_c}</td>

                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                            No students registered yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
                
                
                </div>
            </div>
        </div>
        

        
      
    </AppContainer>
  );
}

export default SchoolBuzztimeCreditBalancesPage;
